
import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL =
  import.meta.env
    .VITE_API_BASE_URL_PROD;

// const BASE_URL =
// import.meta.env
// .VITE_API_BASE_URL_DEV;


const SOCKET_URL =
  import.meta.env
    .VITE_API_SOCKET_URL;


// console.log(
//   "SOCKET_URL",
//   SOCKET_URL
// );


// =======================
// AXIOS INSTANCES
// =======================

export const nonAuthInstance =
  axios.create({

    baseURL:
      BASE_URL,

    headers: {

      'Content-Type':
        'application/json'

    }

  });


export const authInstance =
  axios.create({

    baseURL:
      BASE_URL,

    headers: {

      'Content-Type':
        'application/json'

    }

  });


export const socketInstance =
  axios.create({

    baseURL:
      SOCKET_URL,

    headers: {

      'Content-Type':
        'application/json'

    }

  });


// console.log(
//   authInstance
// );


// =======================
// ATTACH TOKEN
// =======================

const attachToken =
  (config) => {

    const accessToken =
      Cookies.get(
        'accessToken'
      );


    if (
      accessToken
    ) {

      config.headers.Authorization =
        `Bearer ${accessToken}`;

    }


    return config;

  };


const onRequestError =
  (error) =>

    Promise.reject(
      error
    );


authInstance
  .interceptors
  .request
  .use(

    attachToken,

    onRequestError

  );


socketInstance
  .interceptors
  .request
  .use(

    attachToken,

    onRequestError

  );



// =======================
// CLEAR SESSION
// =======================

const clearSessionAndRedirect =
  () => {


    const cookieOptions = {

      secure:

        window.location.protocol ===
        'https:',


      sameSite:

        'strict'

    };


    Cookies.remove(

      'accessToken',

      cookieOptions

    );


    Cookies.remove(

      'refreshToken',

      cookieOptions

    );


    Cookies.remove(

      'user',

      cookieOptions

    );


    window.location.href =
      '/login';

  };

// =======================
// RESPONSE INTERCEPTOR
// =======================

const createResponseInterceptor =
  (instance) => {


    let isRefreshing =
      false;


    let failedQueue =
      [];



    const processQueue =

      (

        error,

        token = null

      ) => {


        failedQueue.forEach(

          (prom) => {


            if (

              error

            ) {

              prom.reject(
                error
              );

            } else {

              prom.resolve(
                token
              );

            }

          }

        );


        failedQueue =

          [];

      };



    instance
      .interceptors
      .response
      .use(


        (response) =>

          response,



        async (

          error

        ) => {


          const originalRequest =
            error.config;



          // Prevent infinite loop
          if (

            originalRequest?.url ===

            '/admin/auth/refresh-token'

          ) {

            clearSessionAndRedirect();

            return Promise.reject(

              error

            );

          }



          // Reject non-401
          if (

            error.response?.status !==

            401 ||

            originalRequest._retry

          ) {

            return Promise.reject(

              error

            );

          }



          // If already refreshing
          if (

            isRefreshing

          ) {

            return new Promise(

              (

                resolve,

                reject

              ) => {


                failedQueue.push({

                  resolve,

                  reject

                });

              }

            )

              .then(

                (

                  token

                ) => {


                  originalRequest.headers =

                    originalRequest.headers ||

                    {};



                  originalRequest
                    .headers
                    .Authorization =

                    `Bearer ${token}`;



                  return instance(

                    originalRequest

                  );

                }

              )

              .catch(

                (

                  err

                ) =>

                  Promise.reject(

                    err

                  )

              );

          }



          originalRequest._retry =

            true;


          isRefreshing =

            true;



          const refreshToken =

            Cookies.get(

              'refreshToken'

            );



          if (

            !refreshToken

          ) {

            clearSessionAndRedirect();

            return Promise.reject(

              error

            );

          }



          try {


            const response =

              await nonAuthInstance.post(

                '/admin/auth/refresh-token',

                {

                  refreshToken

                }

              );



            const {

              tokens

            } =

              response.data;



            const newAccessToken =

              tokens.access.token;



            const accessTokenExpiry =

              tokens.access.expiresIn;




            Cookies.set(

              'accessToken',

              newAccessToken,

              {

                expires:

                  accessTokenExpiry /

                  86400,


                secure:

                  window.location.protocol ===

                  'https:',


                sameSite:

                  'strict'

              }

            );




            // Update defaults
            authInstance
              .defaults
              .headers
              .common
              .Authorization =

              `Bearer ${newAccessToken}`;



            socketInstance
              .defaults
              .headers
              .common
              .Authorization =

              `Bearer ${newAccessToken}`;





            originalRequest.headers =

              originalRequest.headers ||

              {};



            originalRequest
              .headers
              .Authorization =

              `Bearer ${newAccessToken}`;





            processQueue(

              null,

              newAccessToken

            );




            return instance(

              originalRequest

            );


          } catch (

          refreshError

          ) {


            processQueue(

              refreshError,

              null

            );



            clearSessionAndRedirect();



            return Promise.reject(

              refreshError

            );


          } finally {


            isRefreshing =

              false;


          }


        }

      );


  };




// =======================
// APPLY INTERCEPTORS
// =======================

createResponseInterceptor(

  authInstance

);

createResponseInterceptor(

  socketInstance

);


// =======================
// EXPORT
// =======================

export default

  authInstance;